import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CustomerStopGroupControls, ExtractFormControl } from '../models/customer-stop-form.interface';

@Injectable({
  providedIn: 'root',
})
export class CustomerStopHttpService {
  private http = inject(HttpClient);

  submitForm(formData: ExtractFormControl<CustomerStopGroupControls>): Observable<any> {
    return this.http.post('/api/customerstop', formData);
  }
}
